function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 14a13.952 13.952 0 00-9.617 3.826A15.936 15.936 0 002 14v2c4.757 0 8.96 2.373 11.49 6h3.218A7.97 7.97 0 0122 20v-2a9.967 9.967 0 00-6.92 2.782 16.092 16.092 0 00-1.258-1.564A11.958 11.958 0 0122 16v-2zm-11.056 8A11.97 11.97 0 002 18v2c2.252 0 4.33.744 6.001 2h2.943z",
  fill: "#A8B8CA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17 7c0-2.758-2.242-5-5-5S7 4.242 7 7c0 3.75 5 9 5 9s5-5.25 5-9zm-6.667 0c0-.917.75-1.667 1.667-1.667s1.667.75 1.667 1.667a1.666 1.666 0 11-3.334 0z"
});

function SvgTrialSeed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "#A8B8CA",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrialSeed);
export default __webpack_public_path__ + "static/media/trial-seed.0abb24a7.svg";
export { ForwardRef as ReactComponent };